const colour_palettes = [
  {
    pal_num: 1,
    title: "Protractor",

    palette: [
      "#381D00",
      "#D32100",
      "#C27000",
      "#FE3300",
      "#FE9D00",
      "#FFB000",
      "#FFD365",
    ],
    num_clrs: 7,
    source: "sspboyd",
  },
  {
    pal_num: 2,
    title: "SC_Beach",

    palette: [
      "#1C1716",
      "#E21E1D",
      "#F18621",
      "#F2B154",
      "#E5B82B",
      "#EAE18A",
      "#70AEB6",
      "#9ECACB",
      "#B6D5BC",
      "#E6E9DD,",
    ],
    num_clrs: 10,
    source: "sspboyd",
  },
  {
    pal_num: 3,
    title: "Rainbow Neon Scrunchie",

    palette: ["#414E50", "#FD2882", "#6279D0", "#09BBD4", "#BBECEF", "#BFEC2D"],
    num_clrs: 6,
    source: "sspboyd",
  },
  {
    pal_num: 6,
    title: "Queen West Graffiti",
    palette: [
      "#705183",
      "#3E3F3D",
      "#1E3F7E",
      "#FFF300",
      "#BFB29D",
      "#7ACDDD",
      "#EDF1E8",
    ],
    num_clrs: 7,
    source: "sspboyd",
  },
  {
    pal_num: 8,
    title: "Eulalie's Graffiti",
    palette: [
      "#0F1314",
      "#3B958E",
      "#F5F098",
      "#A16C7F",
      "#89B478",
      "#E8C4C4",
      "#DBE8E2",
      "#F2F5F2",
    ],
    num_clrs: 8,
    source: "sspboyd",
  },
  {
    pal_num: 9,
    title: "Morocco",
    palette: [
      "#055054",
      "#79070C",
      "#2FBBB4",
      "#CC510B",
      "#D8CC5E",
      "#DF716B",
      "#E0E1E1",
    ],
    num_clrs: 7,
    source: "sspboyd",
  },
  {
    pal_num: 10,
    title: "Refracted Light",
    palette: ["#435ad9", "#66614e", "#f2766b", "#05c7f2", "#f2ea79"],
    num_clrs: 5,
    source: "sspboyd",
  },
  {
    pal_num: 11,
    title: "Martin's Mailbox",
    palette: ["#4f5902", "#03658c", "#72b6f2", "#eaf205", "#e1edc3"],
    num_clrs: 5,
    source: "sspboyd",
  },
  {
    pal_num: 12,
    title: "Flamingo",
    palette: ["#332830", "#8c0303", "#bf0449", "#f24b88", "#f2f2f2"],
    num_clrs: 5,
    source: "sspboyd",
  },
  {
    pal_num: 13,
    title: "Blue Alley",
    palette: ["#023059", "#731702", "#034c8c", "#d0beaa", "#f2e3b3"],
    num_clrs: 5,
    source: "sspboyd",
  },
  {
    pal_num: 16,
    title: "Craven Mural",
    palette: ["#03318c", "#d13521", "#df8f00", "#f2cb05", "#f2f2f2"],
    num_clrs: 5,
    source: "sspboyd",
  },
];

export { colour_palettes };
